<template>
    <div>

        <rkm-area
            title="Cota"
            no-margin-top
        >
            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                slot="trailing"
                small
                title="Adicionar cota de exame"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <rkm-table
                :items="this.itemsExames"
                :fields="fields.tables.tipo"
                sort-by="unidade"
                ref="DataTable"
             >

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        @click="$refs.Modal.open(index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroy(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

            <Modal
                :data="data"
                ref="Modal"
            />
        </rkm-area>
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

// Moment.
import moment from 'moment'

// Mixins.
import { repository, data, formats } from '@/mixins'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'unidade', label: 'Laboratório', sortable: true },
                        { key: 'infraestrutura', label: 'Local de atendimento', sortable: true },
                        { key: 'tipo', label: 'Tipo', sortable: true },
                        { key: 'inicio', label: 'Início', sortable: true },
                        { key: 'fim', label: 'Fim', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao'),
        }
    },
    data: () => ({
        enums: {
            tipoCota
        },
        cotasAtribuidas: 0,
        cotaAtribuida: 0,
    }),
    methods: {
        handleDestroy(item) {

            this.getCotaAtribuida(item)

            if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > "0,00") {

                this.showValidationNotification(`Não é possível excluir a cota do laboratório
                    <strong>${ item.unidade }</strong> e o local de atendimento
                    <strong>${ item.infraestrutura }</strong>, pois já possui cotas atribuídas.`)

                return false
            }

            const destroy = () => this.repositories.parametrizacao.destroy(item.id)
                .then(() => {
                    this.itemsExames = this.itemsExames.filter(exame => exame.id !== item.id)
                })

            this.showDeleteConfirmation('Deseja realmente excluir a cota do exame?', destroy, this.handleError)
        },
        getCotaAtribuida(cotaExamePeriodo) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio.find((unidade) => unidade.unidadeId == cotaExamePeriodo.unidadeId
                && unidade.infraestruturaId == cotaExamePeriodo.infraestruturaId)

            if (cota) {

                cota.cotaLaboratorio.filter(field => field.cotaTipoId == cotaExamePeriodo.tipoId
                    && moment(

                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        cotaExamePeriodo.inicio.split("/").reverse().join("-"),
                        cotaExamePeriodo.fim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        cotaExamePeriodo.inicio.split("/").reverse().join("-"),
                        cotaExamePeriodo.fim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                ).map(exame => {

                    this.cotaAtribuida = exame.exames
                        .reduce((sum, element) => {

                            if (cotaExamePeriodo.tipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                        return sum
                    },0)

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                })
            }
        },
        getStringUnidade(item) {

            return `${item.unidade} - ${item.infraestrutura}`
        },
    },
    mixins: [repository, data, formats],
    props: {
        data: { type: Object, required: true },
        itemsExames: { type: Array, required: true },
    },
}
</script>

<style scoped>
.popover{
    max-width: 70%;
}
</style>